import { render, staticRenderFns } from "./rewardCooperateTreasureEdit.vue?vue&type=template&id=172184bb&scoped=true&"
import script from "./rewardCooperateTreasureEdit.vue?vue&type=script&lang=js&"
export * from "./rewardCooperateTreasureEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172184bb",
  null
  
)

export default component.exports